
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action } from "vuex-class";
import { AxiosResponse } from "axios";
import AppFooter from "@/components/layout/AppFooter.vue";
import AppNavbarSecondary from "@/components/layout/AppNavbarSecondary.vue";
import { onScroll } from "@/functions/global.function";
import { SchoolEventTargetEnum } from "@/constants/enum.constant";
import EventItem1 from "@/components/items/event/EventItem1.vue";
import EventItem2 from "@/components/items/event/EventItem2.vue";
import EventItem3 from "@/components/items/event/EventItem3.vue";

@Component({
  components: {
    EventItem3,
    EventItem2,
    EventItem1,
    AppNavbarSecondary,
    AppFooter,
  },
  filters,
})
export default class Events extends Vue {
  @Action("getSchoolEvents", { namespace: "school" })
  private getSchoolEvents: any;

  private events: Array<any> = [];
  private page = 1;
  private isLastPage = false;
  private isLoading = false;

  private get templateNumber() {
    return Number(this.$route.query.template) || 1;
  }

  private getData(isReload: boolean = false) {
    if (isReload) {
      this.events = [];
      this.page = 1;
      this.isLastPage = false;
    }
    if (!this.isLoading && !this.isLastPage) {
      this.getSchoolEvents({
        params: {
          page: this.page,
        },
        success: (response: AxiosResponse) => {
          const isLastPage = response.data.data.last_page === this.page;
          this.events = [...this.events, ...response.data.data.data];
          this.page = isLastPage ? this.page : this.page + 1;
          this.isLastPage = isLastPage;
        },
        fail: () => {
          this.$router.push({ name: "landing" });
        },
      });
    }
  }

  private created() {
    this.getData();
  }

  private mounted() {
    onScroll("#app", this.getData);
  }

  private isForCandidate(data: any) {
    return data.target === SchoolEventTargetEnum.CANDIDATE;
  }

  private isForCompany(data: any) {
    return data.target === SchoolEventTargetEnum.COMPANY;
  }
}
